<template>
  <div class="checkbox-container">
    <calico-checkbox
      id="value1"
      v-model="selected"
      value="selected"
    >
      Label
    </calico-checkbox>
    <calico-checkbox
      id="value3"
      v-model="selected"
      value="disabled"
      disabled
    >
      Label
    </calico-checkbox>
    <calico-checkbox
      id="value4"
      v-model="selected"
      value="error"
      error
    >
      Label
    </calico-checkbox>
  </div>
</template>

<script lang="js">
import CalicoCheckbox from '@/components/calico/checkbox/index.vue'
export default {
  name: 'CalicoCheckboxPage',
  components: {
    CalicoCheckbox
  },
  data () {
    return { selected: null }
  },
  watch: {
    selected (value) {
      console.log(value)
    }
  }
}
</script>
<style lang="scss">
.checkbox-container {
  justify-content: center;
  align-items: center;
  @include inset-space($space-xxxlarge);
  @include inline-space($space-medium);
}
</style>
